import { Dialog } from "@octopusdeploy/design-system-components";
import type { PanelRepositorySelectorProps } from "./PanelRepositorySelector";
import PanelRepositorySelector from "./PanelRepositorySelector";
type GitHubConnectionRepositorySelectorProps = {
    isOpen: boolean;
} & PanelRepositorySelectorProps;
export function GitHubConnectionRepositorySelector({ isOpen, ...props }: GitHubConnectionRepositorySelectorProps) {
    return (<Dialog open={isOpen} dialogWidth={"1000px"}>
            <PanelRepositorySelector {...props}/>
        </Dialog>);
}
